export class VersionLoader
{
  private static _version = '1.0.0';
  private static is_loaded = false;

  static async load(): Promise<string>
  {
    if ( this.is_loaded )
      return this._version;

    try
    {
      const random_seed = Math.floor( Math.random() * 1e8 );
      const response = await fetch( `version.json?v=${random_seed}` );

      if ( !response.ok )
      {
        throw new Error( `HTTP ${response.status}` );
      }

      const json = await response.json();

      // Check if Capacitor is available globally (in iOS/Android apps)
      const platform = window.Capacitor?.getPlatform?.() || 'web';

      const major = json.major || '1';
      const minor = json.minor || '0';
      let build = '0';

      if (platform === 'android' && json.android) {
        build = String(json.android.build || 0);
      } else if (platform === 'ios' && json.ios) {
        build = String(json.ios.build || 0);
      } else if (platform === 'web' && json.web) {
        build = String(json.web.build || 0);
      }

      this._version = `${major}.${minor}.${build}`;
      return this._version;
    } catch ( err )
    {
      console.warn( "[VersionLoader] Failed to load JSON, using fallback [1.0.0]", err );
      return this._version;
    } finally
    {
      this.is_loaded = true;
    }
  }

  static getVersion(): string { return this._version; }

  public static getBuildNumber(): number
  {
    const parts = this._version.split( '.' );
    return parseInt( parts[parts.length - 1] ) || 0;
  }
}